import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M8.415 1.5a6.915 6.915 0 1 1 0 13.83 6.915 6.915 0 0 1 0-13.83m0 15.33a8.415 8.415 0 1 0 0-16.83 8.415 8.415 0 0 0 0 16.83m3.016-10.526a.75.75 0 0 0-1.06 0L7.739 8.935l-1.28-1.28A.75.75 0 1 0 5.4 8.717l1.81 1.81a.75.75 0 0 0 1.061 0l3.161-3.161a.75.75 0 0 0 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }